import { OnInit, Component } from '@angular/core';
import { AuthenticationService, PlatformService, SessionService } from '@app/services';
import { ActivatedRoute, Router } from '@angular/router';
import { OIDC_LOGOUT_CALLBACK_PATH, OidcProvider } from '@app/models/authentification-config';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogData } from '@app/components/_common/confirm-dialog/confirm-dialog.component';

@Component({
  template: `
  <mat-card appearance="raised" *ngIf="errorMessage!==''" class="error-container">
    <mat-card-title class="mat-error">
      <mat-icon color="warn" style="float: left; margin-right: 10px;">error</mat-icon>
      <span>Erreur</span>
      <button mat-icon-button aria-label="dismiss" (click)="closeError()" style="float:right;">
        <mat-icon>clear</mat-icon>
      </button>
    </mat-card-title>
    <mat-card-content>
      <pre [innerHTML]="errorMessage" class="mat-error" style="text-align: left;"></pre>
    </mat-card-content>
  </mat-card>
  <app-loader *ngIf="redirecting">
    <h3>{{ redirectingMessage|trans }}</h3>
  </app-loader>
  `,
  standalone: false
})
export class LogoutComponent implements OnInit {

  redirecting = false;
  redirectingMessage = '';
  errorMessage = '';
  oidcProvider: OidcProvider;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private platformService: PlatformService,
  ) { }

  ngOnInit(): void {
    let route = this.activatedRoute.snapshot;
    const isOidcCallback = route.url.some(fragment => OIDC_LOGOUT_CALLBACK_PATH.indexOf(fragment.path) >= 0)

    if (!isOidcCallback) { // si on est sur le retour d'oidc logout, la fin de déconnexion est gérée par startupService.handleOpenIdConnectLogoutCallback()

      this.oidcProvider = this.authService.oidcProviderValue
      if (this.authService.currentUserValue?.fromOIDC && this.oidcProvider?.disconnectProviderAtLogout === 'userChoice') {
        this.askForOidcProviderLogout()
      } else {
        this.logout()
      }
    }
  }

  logout(forceOidcLogout = false) {
    this.redirecting = true;
    this.redirectingMessage = ' Redirection ';

    this.authService.logout(true, forceOidcLogout).subscribe(res => {
      if (res && res.redirectTo) {
        window.location.href = res.redirectTo;
      } else {
        this.router.navigate(['home']); // or 'login' ??
      }
    })

  }

  askForOidcProviderLogout() {
    const dialog = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: `
          <div style="margin:5px;">
            <img src="${this.oidcProvider?.providerLogo}" style="float:left; width: auto; height: auto; max-height: 40px; max-width: 40px; margin: 10px;" />
            Vous êtes actuellement identifié grâce à <b>${this.oidcProvider.providerName}</b>, et vous êtes sur le point de vous déconnecter.
            </div>
          <div style="margin:5px;"> Souhaitez vous également déconnecter votre session sur <b>${this.oidcProvider.providerName}</b> ?</div>
        `,
        confirmText: 'Oui',
        cancelText: 'Non ',
      } as ConfirmDialogData,
      maxWidth: '90vw',
      disableClose: true // Prevent dialog close on press ESC
    });
    this.platformService.adaptDialogToScreen(dialog);

    dialog.afterClosed().subscribe(responseDialog => {
      if (responseDialog) {
        this.logout(true)
      } else {
        this.logout(false)
      }
    });


  }

  closeError() {
    this.errorMessage = '';
    this.router.navigate(['home']); // or 'login' ??
  }
}
